import React, { useEffect, useRef } from 'react';
import { Tooltip } from 'antd';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from "@fullcalendar/interaction";
import './calendarStyles.css';
import moment from 'moment';
import { addfifteenMinutes, capitalizeFirst, formatTimeRange, getAppointmentDuration, subtractFifteenMinutes } from '../Common/CommonFunction';

const CalendarFull = (props) => {
  const calendarRefs = useRef([]);
  const lastWeekStartRef = useRef(null);
  const eventDataByDate = {};
  // Build a product_category_id -> type lookup from localStorage for dynamic appointment coloring
  const _catTypeMap = (() => {
    try {
      const cats = JSON.parse(localStorage.getItem('showCategory') || '[]');
      return cats.reduce((acc, c) => { acc[c.product_category_id] = c.type; return acc; }, {});
    } catch (e) { return {}; }
  })();
  if (props?.data?.appointmentData?.length > 0) {
    try {
      props.data.appointmentData.forEach(data => {
        // eventDataByDate[data.room_id] = data;
        if (data.rooms && data.rooms.length) {
          if (eventDataByDate[data.room_id]) {
            eventDataByDate[data.room_id] = [...eventDataByDate[data.room_id], { ...data }];
          } else {
            eventDataByDate[data.room_id] = [{ ...data }];
          }
        }
      });
    } catch (error) {
      console.error("Error parsing appointment data:", error);
    }
  }

  useEffect(() => {
    if (props.passDate) {
      calendarRefs.current.forEach((ref) => {
        const calendarApi = ref?.getApi?.();
        if (calendarApi) {
          calendarApi.gotoDate(props.passDate);
        }
        if (calendarApi) {
          calendarApi.changeView('timeGridWeek'); // or 'resourceTimeGridWeek'
          calendarApi.gotoDate(props.passDate);
        }
      });
    }
  }, [props.passDate]);

  function getTimeDifferenceInMinutes(startTime, endTime) {
    const start = new Date(`1970-01-01T${startTime.padStart(5, '0')}:00`);
    const end = new Date(`1970-01-01T${endTime.padStart(5, '0')}:00`);
    const diffMs = end - start;
    return diffMs / (1000 * 60);
  }

  const goToNextWeek = () => {
    calendarRefs.current.forEach((ref) => {
      const calendarApi = ref?.getApi?.();
      if (!calendarApi) return;
      calendarApi.next();
    });
  };

  const goToPreviousWeek = () => {
    calendarRefs.current.forEach((calendar) => {
      const calendarApi = calendar?.getApi?.();
      if (calendarApi) {
        calendarApi.prev();
      }
    });
  };
  const handleDatesSet = (arg) => {
    const startDate = arg.start;
    const formatted = moment(startDate).format("YYYY-MM-DD");
    if (lastWeekStartRef.current !== formatted) {
      lastWeekStartRef.current = formatted;
      // if (props.callBackNextOrPrev) {
      //   // props.callBackNextOrPrev(moment(formatted));
      // }
    }
  };
  return (
    <>
      {/* <button onClick={goToNextWeek}>Next Week</button>
      <button onClick={goToPreviousWeek}>Previous Week</button> */}

      {props?.clinic?.rooms?.map((room, i) => {
        const dataForEvent = [];
        if (room?.id && eventDataByDate[room.id] && eventDataByDate[room.id].length) {
          room?.id && eventDataByDate[room.id].map(sigledata => {
            sigledata.rooms.forEach((item) => {
              let obj = {};
              const start = moment(item.start_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss");
              const end = moment(item.end_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss");

              if (item.type === "lunch" || item.type === "spacer" || item.type === "block") {
                obj = {
                  title: item.type?.toUpperCase() ?? item.name,
                  start,
                  end,
                  backgroundColor: item.type === "block" ? '#A4A4A4' : item.type === "lunch" ? '#A4A4A4' : '#D1D1D1',
                  borderColor: item.type === "block" ? '#A4A4A4' : item.type === "lunch" ? '#A4A4A4' : '#D1D1D1',
                  textColor: '#4A4A4A',
                  data: { ...item, room_name: sigledata.room_name, room_type: sigledata.room_type },
                };
              } else if (item.type === "appointment") {
                obj = {
                  title: `${formatTimeRange(item.start_time, item.end_time).start} - ${item?.patient?.first_name}`,
                  start,
                  end,
                  backgroundColor: (_catTypeMap[item?.product_category_id] === 'corporate' || item?.product_category_id == 3) ? '#90CAF9' : '#008385',
                  borderColor: (_catTypeMap[item?.product_category_id] === 'corporate' || item?.product_category_id == 3) ? '#90CAF9' : '#008385',
                  textColor: '#F0FAFA',
                  textAlign: 'center',
                  data: { ...item, room_name: sigledata.room_name, room_type: sigledata.room_type },
                };
              } else if (item && (item.type === 'lantum')) {
                const spacerEvent = {
                  title: item.type?.toUpperCase() ?? 'lantum',
                  resourceId: item.room_id,
                  start: moment(subtractFifteenMinutes(item.lantum_start_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                  end: moment((item.lantum_start_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                  backgroundColor: '#4A4A4A',
                  borderColor: '#4A4A4A',
                  textColor: '#fff',
                  data: { ...item, room_name: sigledata.room_name, room_type: sigledata.room_type },
                };
                const spacerEventNew = {
                  title: item.type?.toUpperCase() ?? 'lantum',
                  resourceId: item.room_id,
                  start: moment((item.lantum_end_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                  end: moment(addfifteenMinutes(item.lantum_end_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                  backgroundColor: '#4A4A4A',
                  borderColor: '#4A4A4A',
                  textColor: '#fff',
                  data: { ...item, room_name: sigledata.room_name, room_type: sigledata.room_type },
                };
                dataForEvent.push(spacerEventNew);
                dataForEvent.push(spacerEvent);
              }

              dataForEvent.push(obj);
            });
          })

        }
        return (
          <div
            key={i}
            className="fullcalendar-wrapper"
            style={{ border: '1px solid #eee', borderRadius: 8 }}
          >
            <div style={{
              background: '#d6edf1',
              padding: '10px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '16px',
              borderBottom: '1px solid #ccc'
            }}>
              {(() => {
                const roomInfo = props.data?.appointmentData?.find(d => d.room_id === room.id);
                if (roomInfo && roomInfo.room_name) {
                  return `${roomInfo.room_name} ${roomInfo.room_type ? '- ' + roomInfo.room_type : ''}`;
                }
                return room?.name || `Room ${i + 1}`;
              })()}
            </div>

            <FullCalendar
              ref={(el) => (calendarRefs.current[i] = el)}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="timeGridWeek"
              initialDate={props.passDate || moment().format("YYYY-MM-DD")}
              datesSet={handleDatesSet}
              allDaySlot={false}
              headerToolbar={false}
              windowResize={true}
              // slotMinTime="08:00:00"
              // slotMaxTime="20:00:00"
              // slotMinTime="00:00:00"
              // slotMaxTime="24:00:00"
              slotMinTime="06:00:00"
              slotMaxTime="22:00:00"
              slotDuration="00:60:00"
              slotLabelFormat={{ hour: 'numeric', minute: '2-digit', meridiem: 'long' }}
              scrollTime="08:00:00"
              height="auto"
              firstDay={1}
              hiddenDays={[]}
              events={dataForEvent}
              eventClassNames="calenderEvent"
              dayCellClassNames="calendarDays"
              dayHeaderClassNames="calendarHeader"
              dayHeaderFormat={{ weekday: 'short', day: 'numeric' }}
              dayHeaderContent={(arg) => {
                const dayName = arg.date.toLocaleDateString('en-GB', { weekday: 'short' }).toUpperCase();
                const dateNumber = arg.date.getDate();

                return (
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontWeight: 'bold' }}>{dayName}</div>
                    <div
                      style={{
                        marginTop: 6,
                        backgroundColor: '#008080',
                        color: '#fff',
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 12,
                      }}
                    >
                      {dateNumber}
                    </div>
                  </div>
                );
              }}
              eventContent={(eventInfo) => {
                const eventData = eventInfo?.event?._def?.extendedProps?.data;

                // For lantum events with clinicians, wrap with Tooltip
                if (eventData?.type === 'lantum' && eventData?.clinicians && eventData.clinicians.length > 0) {
                  const tooltipContent = (
                    <div>
                      {eventData.clinicians.map((clinician, index) => {
                        const startTime = moment(clinician.start).format('hh:mm a');
                        const endTime = moment(clinician.end).format('hh:mm a');
                        const gender = clinician.clinician_gender ? 
                          (clinician.clinician_gender.toLowerCase() === 'male' ? '(M)' : 
                            clinician.clinician_gender.toLowerCase() === 'female' ? '(F)' : '') : '';
                        return (
                          <div key={index} style={{ marginBottom: index < eventData.clinicians.length - 1 ? '4px' : 0 }}>
                            {clinician.clinician_name} {clinician.clinician_surname} {gender && ` ${gender}`} | {startTime} - {endTime}
                          </div>
                        );
                      })}
                    </div>
                  );
                  return (
                    <Tooltip title={tooltipContent} color="#008385">
                      {eventInfo.event.title}
                    </Tooltip>
                  );
                }
                if (eventData?.type === 'spacer' || eventData?.type === 'block' || eventData?.type === "lunch") {
                  const startTime = moment.utc(eventData.start_time).format('hh:mm a');
                  const endTime = moment.utc(eventData.end_time).format('hh:mm a');
                  const tooltipContent = (
                    <div>
                      <div>
                        {eventData.name} | {startTime} - {endTime}
                      </div>
                    </div>
                  );
                  return (
                    <Tooltip title={tooltipContent} color="#008385">
                      {eventInfo.event.title}
                    </Tooltip>
                  );
                }

                // Default rendering for other events
                return (
                  <div>{eventInfo.event.title}</div>
                );
              }}
              eventClick={(info) => {
                // console.log('::::info:::', info?.event?._def?.extendedProps)
                if (info) {
                  props.openModal(info.el, info.event);
                }
              }}
            />
          </div>
        );
      })}
    </>
  );
};

export default CalendarFull;
